import React from 'react';
import { Calendar, MapPin, Clock, Ticket } from 'lucide-react';
import { Link } from 'react-router-dom';

const FeaturedEvent = () => {
const showFeaturedEvent = false;

if (!showFeaturedEvent) return null;

return (
<section className="bg-zinc-950 py-20 md:py-32" aria-labelledby="featured-event-heading" >
<div className="container mx-auto px-6">

    <div className="text-center mb-16">
      <h2
        id="featured-event-heading"
        className="text-white text-5xl md:text-6xl font-bold mb-6"
      >
        Upcoming Boxing Events
      </h2>

      <p className="text-gray-400 text-lg">
        Experience the excitement of live boxing events in Botswana.
      </p>
    </div>

    <div className="max-w-5xl mx-auto">
      <div className="grid md:grid-cols-2 gap-8 items-center">

        {/* Event Poster */}
        <div className="relative h-[500px] overflow-hidden group">
          <img
            src="https://images.unsplash.com/photo-1770734265410-0c686b750f0f"
            alt="Boxing event atmosphere at Bond Boxing"
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
        </div>

        {/* Event Details */}
        <div>

          <h3 className="text-white text-4xl font-bold mb-6">
            Bond Boxing Fight Night
          </h3>

          <div className="space-y-4 mb-8">

            <div className="flex items-center gap-4">
              <Calendar className="text-red-500" size={24} aria-hidden="true" />
              <span className="text-gray-300 text-lg">
                Event date to be announced
              </span>
            </div>

            <div className="flex items-center gap-4">
              <Clock className="text-red-500" size={24} aria-hidden="true" />
              <span className="text-gray-300 text-lg">
                Event time to be announced
              </span>
            </div>

            <div className="flex items-center gap-4">
              <MapPin className="text-red-500" size={24} aria-hidden="true" />
              <span className="text-gray-300 text-lg">
                Gaborone, Botswana
              </span>
            </div>

          </div>

          <div className="border-t border-gray-700 pt-6 mb-8">

            <div className="text-red-500 font-semibold mb-2">
              BOND BOXING EVENTS
            </div>

            <p className="text-gray-400">
              Discover boxing events, fight nights and amateur
              tournaments organised by Bond Boxing. Follow our
              announcements for upcoming events and opportunities
              to experience competitive boxing in Botswana.
            </p>

          </div>

          <div className="flex flex-col sm:flex-row gap-4">

            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-semibold transition-all duration-300 hover:scale-105"
            >
              <Ticket size={20} aria-hidden="true" />
              Make an Enquiry
            </Link>

            <Link
              to="/events"
              className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 font-semibold transition-all duration-300 text-center"
            >
              View All Events
            </Link>

          </div>

        </div>
      </div>
    </div>
  </div>
</section>

);
};

export default FeaturedEvent;